(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function initialiseGallery(gallery) {
    if (!mobile.matches || gallery.dataset.mobileGalleryReady === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const items = [...gallery.querySelectorAll('.product__media-item[data-media-id]')];
    const previous = viewer?.querySelector('.slider-button--prev');
    const next = viewer?.querySelector('.slider-button--next');
    if (!viewer || !items.length || !previous || !next) return;

    gallery.dataset.mobileGalleryReady = 'true';

    const visibleItems = () => items.filter((item) => !item.classList.contains('is-color-filter-hidden'));

    const activeIndex = () => {
      const availableItems = visibleItems();
      const index = availableItems.findIndex((item) => item.classList.contains('is-active'));
      return index < 0 ? 0 : index;
    };

    const ensureActive = () => {
      if (!items.some((item) => item.classList.contains('is-active'))) items[0].classList.add('is-active');
      previous.disabled = false;
      next.disabled = false;
      previous.removeAttribute('disabled');
      next.removeAttribute('disabled');
      previous.setAttribute('aria-disabled', 'false');
      next.setAttribute('aria-disabled', 'false');
    };

    const show = (direction) => {
      const availableItems = visibleItems();
      if (!availableItems.length) return;
      const index = (activeIndex() + direction + availableItems.length) % availableItems.length;
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(availableItems[index].dataset.mediaId, false);
      } else {
        items.forEach((item) => item.classList.toggle('is-active', item === availableItems[index]));
      }
      ensureActive();
    };

    previous.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      show(-1);
    }, true);

    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      show(1);
    }, true);

    new MutationObserver(ensureActive).observe(viewer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
    ensureActive();
  }

  const initialise = () => document.querySelectorAll('media-gallery').forEach(initialiseGallery);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initialise) : initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

/* Filter product media only from the selected colour option. Size and other
   option radios deliberately never participate in this filter. */
(() => {
  const normalise = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const colourFieldset = (root) => [...root.querySelectorAll('fieldset.product-form__input')].find((fieldset) => {
    const label = normalise(fieldset.querySelector('legend')?.textContent.split(':')[0]);
    return label === 'color' || label === 'colour';
  });

  function filterGallery(productInfo) {
    const picker = productInfo.querySelector('variant-selects');
    const fieldset = picker && colourFieldset(picker);
    const selected = fieldset?.querySelector('input[type="radio"]:checked');
    const gallery = productInfo.querySelector('media-gallery');
    if (!selected || !gallery) return;

    const selectedColour = normalise(selected.value || selected.dataset.optionValue);
    if (!selectedColour) return;

    const mediaItems = [...gallery.querySelectorAll('.product__media-item[data-media-id]')];
    const matchingIds = new Set();

    mediaItems.forEach((item) => {
      const alt = normalise(item.querySelector('img')?.getAttribute('alt'));
      if (alt && (alt === selectedColour || alt.includes(selectedColour))) {
        matchingIds.add(item.dataset.mediaId);
      }
    });

    /* Bad/missing alt data must never leave the PDP blank. */
    const hasMatches = matchingIds.size > 0;
    mediaItems.forEach((item) => {
      item.classList.toggle('is-color-filter-hidden', hasMatches && !matchingIds.has(item.dataset.mediaId));
    });

    gallery.querySelectorAll('.thumbnail-list__item[data-target]').forEach((thumbnail) => {
      thumbnail.classList.toggle(
        'is-color-filter-hidden',
        hasMatches && !matchingIds.has(thumbnail.dataset.target)
      );
    });

    const active = mediaItems.find((item) => item.classList.contains('is-active'));
    if (active?.classList.contains('is-color-filter-hidden')) active.classList.remove('is-active');

    const firstVisible = mediaItems.find((item) => !item.classList.contains('is-color-filter-hidden'));
    if (firstVisible && (!active || active.classList.contains('is-color-filter-hidden'))) {
      gallery.setActiveMedia?.(firstVisible.dataset.mediaId, false);
    }

    gallery.querySelector('[id^="GalleryThumbnails"]')?.resetPages?.();
    gallery.querySelector('[id^="GalleryViewer"]')?.resetPages?.();
  }

  const filterAll = () => document.querySelectorAll('product-info').forEach(filterGallery);
  const scheduleFilter = () => {
    window.setTimeout(filterAll, 60);
    window.setTimeout(filterAll, 350);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('variant-selects input[type="radio"]');
    if (!input) return;
    const fieldset = input.closest('fieldset.product-form__input');
    const label = normalise(fieldset?.querySelector('legend')?.textContent.split(':')[0]);
    if (label === 'color' || label === 'colour') scheduleFilter();
  });

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', scheduleFilter) : scheduleFilter();
  document.addEventListener('shopify:section:load', scheduleFilter);
})();
